import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../helpers/Firebase';
import { servicePath, storagePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import moment from 'moment';
import { 
  REQUEST_LIST,
  REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT,
  REQUEST_ADD,
  REQUEST_DETAIL,
  REQUEST_UPDATE,
  REQUEST_UPLOAD_SET
} from '../actions';
import {
  RequestListSuccess,
  RequestListError,
  RequestSearchDeliveryOrderLineLotSuccess,
  RequestSearchDeliveryOrderLineLotError,
  RequestAddSuccess,
  RequestAddError,
  RequestDetailSuccess,
  RequestDetailError,
  RequestUpdateSuccess,
  RequestUpdateError,
  RequestUploadSetSuccess,
  RequestUploadSetError
} from '../actions';
 
export function* watchRequestList() {
  yield takeEvery(REQUEST_LIST, onRequestList);
}

export function* watchRequestSearchDeliveryOrderLineLot() {
  yield takeEvery(REQUEST_SEARCH_DELIVERY_ORDER_LINE_LOT, onRequestSearchDeliveryOrderLineLot);
}

export function* watchRequestAdd() {
  yield takeEvery(REQUEST_ADD, onRequestAdd);
}

export function* watchRequestDetail() {
  yield takeEvery(REQUEST_DETAIL, onRequestDetail);
}

export function* watchRequestUpdate() {
  yield takeEvery(REQUEST_UPDATE, onRequestUpdate);
}

export function* watchRequestUpload() {
  yield takeEvery(REQUEST_UPLOAD_SET, onRequestUpload);
}

const onRequestListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onRequestUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onRequestSearchDeliveryOrderLineLotAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_order_line_lot', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onRequestAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onRequestDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onRequestUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/request/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_requests/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_requests/'});
      });
    });
  });
};


function* onRequestList(data) {
  try {
    const response = yield call(onRequestListAsync, data.payload);
    yield put(RequestListSuccess(response.data));
  } catch (error) {
    yield put(RequestListError(error));
  }
}

function* onRequestSearchDeliveryOrderLineLot(data) {
  try {
    const response = yield call(onRequestSearchDeliveryOrderLineLotAsync, data.payload);
    yield put(RequestSearchDeliveryOrderLineLotSuccess(response.data));
  } catch (error) {
    yield put(RequestSearchDeliveryOrderLineLotError(error));
  }
}

function* onRequestAdd(data) {
  try {
      const response = yield call(onRequestAddAsync, data);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(RequestAddSuccess(response.data));
  } catch (error) {
      yield put(RequestAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onRequestDetail(data) {
  try {
    const response = yield call(onRequestDetailAsync, data.payload);
    yield put(RequestDetailSuccess(response.data.data));
  } catch (error) {
    yield put(RequestDetailError(error));
  }
}

function* onRequestUpdate(data) {
  try {
      const response = yield call(onRequestUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(RequestUpdateSuccess(response.data));
  } catch (error) {
      yield put(RequestUpdateError(error));
  }
}

function* onRequestUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onRequestUploadAsync, file);
    if(response.message ==='success'){
      yield put(RequestUploadSetSuccess(response));
    }
    else{
      yield put(RequestUploadSetError(response));
    }
  } catch (error) {
    yield put(RequestUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchRequestList),
    fork(watchRequestSearchDeliveryOrderLineLot),
    fork(watchRequestAdd),
    fork(watchRequestDetail),
    fork(watchRequestUpdate),
    fork(watchRequestUpload),
  ]);
} 